import { render, staticRenderFns } from "./crm-show.vue?vue&type=template&id=12b0637f&"
import script from "./crm-show.vue?vue&type=script&lang=js&"
export * from "./crm-show.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports